var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9993 14.9999C17.7733 14.9999 17.5463 14.9239 17.3593 14.7679L11.9883 10.2919L6.62626 14.6069C6.19726 14.9539 5.56726 14.8859 5.22026 14.4549C4.87426 14.0249 4.94226 13.3959 5.37326 13.0489L11.3733 8.22092C11.7433 7.92192 12.2743 7.92592 12.6403 8.23192L18.6403 13.2319C19.0643 13.5849 19.1213 14.2159 18.7683 14.6399C18.5703 14.8769 18.2863 14.9999 17.9993 14.9999Z",
    fill: "#8F9BB3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpPage);
export default __webpack_public_path__ + "static/media/up-page.8ffcb012c077d3a20da1341eba13e32a.svg";
export { ForwardRef as ReactComponent };